import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/enterprise-design-system/page.tsx");
